<div class="modal-header text-white bg-primary">
  <h5 class="modal-title text-white">{{ 'editOutputSchedule' | translate:{ output: selectedOutput } }}</h5>
  <button type="button" class="btn-close btn-close-white fs-2 fw-bold" (click)="closeModal()"></button>
</div>

<div class="modal-body" style="min-height: 80vh; ">

  <div class="d-flex justify-content-end mb-3">
    <div class="btn-group btn-group-sm" role="group" [attr.aria-label]="'editModeAria' | translate">
      <button
        type="button"
        class="btn"
        [ngClass]="list ? 'btn-primary' : 'btn-outline-primary'"
        (click)="list = true"
      >
        {{ 'scheduleListMode' | translate }}
      </button>
      <button
        type="button"
        class="btn"
        [ngClass]="!list ? 'btn-primary' : 'btn-outline-primary'"
        (click)="list = false; ngAfterViewInit()"
      >
        {{ 'scheduleDailyMode' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="list">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 class="mb-0">{{ 'scheduleProgramsList' | translate }}</h6>
      <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="addProgram()">
      <i class="fas fa-plus"></i>
    </button>
  </div>

    </div>


    <div class="table-responsive">
      <table class="table table-sm table-striped align-middle mb-0">
        <thead>
          <tr>
            <th class="text-nowrap">{{ 'scheduleProgramLabel' | translate }}</th>
            <th class="text-nowrap">{{ 'type' | translate }}</th>
            <th class="text-nowrap">{{ 'channel' | translate }}</th>
            <th class="text-nowrap">{{ 'programSection_action' | translate }}</th>
            <th class="text-nowrap">{{ 'time' | translate }}</th>
            <th class="text-nowrap">{{ 'correction' | translate }}</th>
            <th class="text-nowrap">{{ 'weekDays' | translate }}</th>
            <th class="text-nowrap">{{ 'period' | translate }}</th>
            <th class="text-nowrap">{{ 'action' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of schedulerData">
            <td class="text-nowrap">{{ item.id + 1 }}</td>
            <td class="text-nowrap">
              <div *ngIf="!item.edit">{{ getTypeLabel(item.type) }}</div>
              <select name="type" id="type{{ item.id }}" [(ngModel)]="item.type" *ngIf="item.edit">
                <option value=0>{{ 'off' | translate }}</option>
                <option value=1>{{ 'on' | translate }}</option>
                <option value=2>{{ 'programKind_pulse' | translate }}</option>
                <option value=3>{{ 'programKind_cycle' | translate }}</option>
              </select>
            </td>
            <td class="text-nowrap">
              <div *ngIf="!item.edit">
                {{ getChannelLabel(item.channel) }}
              </div>
              <select name="channel" id="channel" [(ngModel)]="item.channel" *ngIf="item.edit">
                <option value=1>C1</option>
                <option value=2>C2</option>
                <option value=3>{{ 'channelBoth' | translate }}</option>
              </select>
            </td>
            <td class="text-nowrap">
              <div *ngIf="!item.edit">
                {{ getModeLabel(item.mode) }}
              </div>
              <select name="mode" id="mode" [(ngModel)]="item.mode" *ngIf="item.edit">
                <option value=16>{{ 'fixedTime' | translate }}</option>
                <option value=1>{{ 'sunset' | translate }}</option>
                <option value=2>{{ 'sunrise' | translate }}</option>
                <option value=4>{{ 'programKind_reductionIni' | translate }}</option>
                <option value=8>{{ 'programKind_reductionEnd' | translate }}</option>
              </select>
            </td>

            <td class="text-nowrap">
              <div *ngIf=" item.mode == 1" >
                {{ sunTimes?.[0]?.sunsetStr}}
              </div>
              <div *ngIf=" item.mode == 2" >
                {{ sunTimes?.[0]?.sunriseStr}}
              </div>
              <div *ngIf="!item.edit && (item.mode != 1 && item.mode != 2)">
                {{ _utils.getDateFromMinutes(item.time)  }}
              </div>
              <input type="time" class="form-control form-control-sm" [(ngModel)]="item.timeStr" *ngIf="item.edit && item.mode == 16"  >
            </td>

            <td class="text-nowrap">
              <div *ngIf="!item.edit && (item.mode == 1 || item.mode == 2)">
                  {{ _utils.getDateFromMinutes(item.time)  }}
              </div>
                <div *ngIf="item.edit && (item.mode == 1 || item.mode == 2)">
              <input type="time" class="form-control form-control-sm" [(ngModel)]="item.timeStr"   >
              </div>
            </td>

            <td>
              <div class="d-flex align-items-center flex-wrap gap-1" *ngIf="!item.edit">
                <span
                  *ngFor="let day of daysOfWeek"
                  class="badge rounded-pill "
                   style="width: 20px; height: 20px;"
                  [ngClass]="isDaySelected(item.daymask, day.value) ? 'bg-primary text-white' : 'bg-secondary bg-opacity-10 text-muted'"
                  [attr.title]="getDayLabel(day.index)"
                >
                  {{ day.short }}
                </span>
              </div>
              <div *ngIf="item.edit">
                <div class="d-flex align-items-center flex-wrap gap-1">
                  <button
                    *ngFor="let day of daysOfWeek"
                    type="button"
                    class="btn btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                    style="width: 20px; height: 20px;"
                    [ngClass]="isDaySelected(item.daymask, day.value) ? 'btn-primary' : 'btn-outline-secondary'"
                    [attr.title]="getDayLabel(day.index)"
                    (click)="toggleDay(item, day.value)"
                  >
                    <span class="fw-semibold">{{ day.short }}</span>
                  </button>
                </div>
              </div>
            </td>
            <td class="text-nowrap">
              <div *ngIf="!item.edit">
                {{ item.festive == 0 ? '-' : item.festive }}
              </div>
              <select name="festive" id="festive" [(ngModel)]="item.festive" *ngIf="item.edit">
                <option value=0>-</option>
                <option value=1>P1</option>
                <option value=2>P2</option>
                <option value=3>P3</option>
                <option value=4>P4</option>
              </select>
            </td>
            <td>
              <div class="d-flex align-items-center gap-2">
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0 text-primary"
                  (click)="item.edit = true"
                  [attr.aria-label]="'editSchedule' | translate"
                  [title]="'edit' | translate"
                >
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-link p-0 text-danger"
                  [attr.aria-label]="'deleteScheduleAria' | translate"
                  [title]="'delete' | translate"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <div *ngIf="!list">



    <app-days-of-week-selector [selectedDay]="selectedDay" (daySelected)="onDaySelected($event)">
    </app-days-of-week-selector>

    <div class="row">

      <div class="col-8 mt-3">
        <!-- Gráfico -->
        <div class="chart-container" style="position: relative; height: 400px; width: 100%;">
          <canvas id="editScheduler" #editCanvas></canvas>
        </div>

      </div>

      <div class="col-4">
        <h6 class="fw-bold mb-3">{{ 'scheduledEventsForDay' | translate:{ day: getSelectedDayLabel() } }}</h6>
        <div class="bg-light border rounded-3 h-100 d-flex flex-column p-3">

          <!-- Si no hay eventos -->
          <div *ngIf="dayData.length === 0" class="text-center text-muted py-4">
            <i class="fas fa-calendar-times fa-2x mb-2"></i>
            <p class="mb-0">{{ 'noScheduledEventsForDay' | translate }}</p>
          </div>

          <!-- Lista de eventos -->
          <div class="events-list overflow-auto flex-fill">
            <div *ngFor="let item of dayData; let i = index"
              class="bg-white rounded-3 py-1 px-3 mb-2 shadow-sm position-relative event-card-hover"
              style="border: 1px solid #dee2e6;" [ngStyle]="{
                 'border-left': item.type === 'sunrise' ? '4px solid #ff9800' :
                                item.type === 'sunset' ? '4px solid #2e8eaa' :
                                '4px solid #0d6efd'
               }" (mouseenter)="onEventHover(getAdjustedTime(item), item.type)" (mouseleave)="onEventLeave()">

              <button type="button" (click)="deletePrograman(i)"
                class="btn btn-sm btn-link text-danger p-0 position-absolute top-0 end-0 mt-1 me-2"
                [attr.aria-label]="'deleteScheduleAria' | translate" [title]="'deleteScheduleAria' | translate">
                <i class="fa-solid fa-trash"></i>
              </button>

              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="d-flex align-items-center gap-2">
                  <!-- Icono según tipo -->
                  <svg *ngIf="item.type === 'sunrise'" class="text-warning flex-shrink-0"
                    style="width: 18px; height: 18px;" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2">
                    <path
                      d="M12 2v6M6.34 6.34l4.24 4.24M2 12h6M6.34 17.66l4.24-4.24M12 16v6M17.66 17.66l-4.24-4.24M22 12h-6M17.66 6.34l-4.24 4.24" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  <svg *ngIf="item.type === 'sunset'" class="flex-shrink-0"
                    style="width: 18px; height: 18px; color: #2e8eaa;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                  </svg>
                  <svg *ngIf="item.type === 'fixed'" class="flex-shrink-0"
                    style="width: 18px; height: 18px; color: #0d6efd;" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M12 6v6l4 2" />
                  </svg>
                  <span class="fw-bold text-dark" style="font-size: 1.1rem; font-family: monospace;">{{
                    getAdjustedTime(item) }}</span>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <span class="badge rounded-pill shadow-sm" [ngClass]="item.action === 1 ? 'bg-success' : 'bg-danger'"
                    style="cursor: pointer; user-select: none;" (click)="toggleAction(item)"
                    [title]="'toggleOutputStateTitle' | translate">
                    {{ item.action === 1 ? ('on' | translate) : ('off' | translate) }}
                  </span>

                  <span class="badge rounded-pill bg-light text-dark me-2"
                    [class.invisible]="!item.period || item.period === 0"
                    [ngbTooltip]="getFestivePeriodTooltip(item.period)"
                    [disableTooltip]="!item.period || item.period === 0" placement="top" container="body">
                    P{{ item.period || 0 }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <!-- Dropdown para cambiar tipo -->
                  <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-sm btn-light border dropdown-toggle" data-bs-toggle="dropdown"
                      aria-expanded="false" style="font-size: 0.75rem; padding: 0.15rem 0.5rem;">
                      {{ getEventTypeLabel(item.type) }}
                    </button>
                    <ul class="dropdown-menu dropdown-menu-sm" style="min-width: 120px;">
                      <li>
                        <a class="dropdown-item small" href="javascript:void(0)"
                          (click)="changeEventType(item, 'sunrise')" [class.active]="item.type === 'sunrise'">
                          {{ getEventTypeLabel('sunrise') }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item small" href="javascript:void(0)"
                          (click)="changeEventType(item, 'sunset')" [class.active]="item.type === 'sunset'">
                          {{ getEventTypeLabel('sunset') }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item small" href="javascript:void(0)"
                          (click)="changeEventType(item, 'fixed')" [class.active]="item.type === 'fixed'">
                          {{ getEventTypeLabel('fixed') }}
                        </a>
                      </li>
                    </ul>
                  </div>

                  <span *ngIf="(item.type === 'sunrise' || item.type === 'sunset') && item.offset !== 0"
                    class="small text-muted">
                    {{ item.time }}
                    <i class="fas fa-arrow-right mx-1"></i>
                    <span class="text-primary fw-semibold">
                      {{ formatOffsetMinutes(item.offset) }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>


    <!-- Instrucciones -->
    <div class="alert alert-info mt-3 py-3 ps-2">
      <small class="text-dark">{{ 'schedulerDragTip' | translate }}</small>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="saveChanges()">{{ 'tourConnectivitySaveTitle' | translate }}</button>
</div>
